import { render, staticRenderFns } from "./sideMenu.vue?vue&type=template&id=62720e54&scoped=true"
import script from "./sideMenu.vue?vue&type=script&lang=js"
export * from "./sideMenu.vue?vue&type=script&lang=js"
import style0 from "./sideMenu.vue?vue&type=style&index=0&id=62720e54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62720e54",
  null
  
)

export default component.exports